<template>
  <th class="ts-w-3" />
</template>

<script>
export default {
  name: 'ExpandableHead'
}
</script>
